<script setup>
import { useCommonImports } from '~/common/composables/common-imports.composable';

const props = defineProps({
  widgetConfig: {
    type: Object,
    required: true,
  },
  isEditing: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['edit', 'duplicate', 'delete']);

const HawkWysiwygEditorComponent = defineAsyncComponent(() => import('~/common/components/organisms/hawk-wysiwyg-editor/hawk-wysiwyg-editor.vue'));

const { $t } = useCommonImports();
</script>

<template>
  <div class="h-full scrollbar -mr-2 pr-2 bi-rich-text-widget" :class="props.widgetConfig.chart.is_vertically_centered ? 'bi-vertically-centered-rich-text-widget' : ''">
    <div class="h-full flex flex-col" :class="props.widgetConfig.chart.is_vertically_centered ? 'justify-center' : ''">
      <div class="relative group flex-shrink-0">
        <HawkWysiwygEditorComponent
          :model-value="props.widgetConfig.chart.content"
          :editor_enabled="false"
          :display_images_fullwidth="false"
          :menu_enabled="false"
          :resize_config="{ quality: 1, maxWidth: 1280, maxHeight: 800 }"
          :plugins="['tables', 'images']"
          :editor_classes="`py-1 ${props.isEditing ? '!cursor-move' : ''}`"
        />
      </div>
      <div
        v-if="props.isEditing"
        class="absolute top-0 right-0 gap-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex bg-white border rounded shadow-sm p-1"
      >
        <IconHawkEditFive
          v-tippy="{
            content: $t('Edit'),
            placement: 'top',
          }"
          class="w-4 h-4 text-gray-600 outline-0 cursor-pointer hover:text-gray-800"
          @click="emit('edit')"
        />
        <IconHawkCopyFour
          v-tippy="{
            content: $t('Duplicate'),
            placement: 'top',
          }"
          class="w-4 h-4 text-gray-600 outline-0 cursor-pointer hover:text-gray-800"
          @click="emit('duplicate')"
        />
        <IconHawkTrashThree
          v-tippy="{
            content: $t('Delete'),
            placement: 'top',
          }"
          class="w-4 h-4 text-gray-600 outline-0 cursor-pointer hover:text-gray-800"
          @click="emit('delete')"
        />
      </div>
    </div>
  </div>
</template>
